(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
    var announcementbars = document.querySelectorAll('.announcement-bar');
    if( announcementbars ) {
      announcementbars.forEach( (announcementbar) =>{
        var closeBar = announcementbar.querySelector('.announcement-bar-close-js');
        if( closeBar ) {
          closeBar.addEventListener('click', ()=>{
            announcementbar.style.display = "none";
          });
        }
      })
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    

 new Swiper('.collection-list-slider-js', {
    slidesPerView: 1.265,
    spaceBetween: 8,
    loop: false,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-bundles"] && !Shopify.designMode) return;
  try {
    
    // Swiper Pagination
    const galleryTop = new Swiper(".featured-bundles-slider .gallery", {
        spaceBetween: 0,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        loop: true,
        mousewheel: {
            enabled: true,
            forceToAxis: true,
        }
    });

    // Changing tab properties to hover
    const featuredBundles = document.querySelectorAll('.featured-bundles');
    const featuredBundlesSlider = document.querySelector('.featured-bundles-slider');
    featuredBundles.forEach(element => {
        const buttonElms = element.querySelectorAll('.nav-tabs li button');
        buttonElms.forEach(button => {
            button.addEventListener('mouseover',debounce(()=>{
                // button.click();
                buttonElms.forEach(button => {
                    button.classList.remove('active');
                })
                const buttonBs = button.getAttribute('data-bs-target');
                button.classList.add('active');
                if( buttonBs ) {
                    document.querySelector(buttonBs).classList.add('active');

                    featuredBundlesSlider.querySelectorAll('.swiper-slide').forEach(element => {
                        element.classList.remove('active');
                    });
                    featuredBundlesSlider.querySelector(buttonBs).classList.add('active');

                }
            }, 250))
        });
    });
    function customCursor(){
        const featuredBundlesSliders = document.querySelectorAll('.featured-bundles-slider');
        if(featuredBundlesSliders){
            featuredBundlesSliders.forEach((featuredBundleSlider)=>{
                    const featuredBundlegallery = featuredBundleSlider.querySelector('.gallery');
                    let customCursor = document.querySelector(".custom-cursor");
                    featuredBundlegallery.addEventListener('mouseenter', (e)=>{
                        customCursor.classList.add('d-block');
                        customCursor.style.left = e.clientX + "px";
                        customCursor.style.top = e.clientY + "px";
                    })
                    featuredBundlegallery.addEventListener('mousemove', (e)=>{
                        customCursor.style.left = e.clientX + "px";
                        customCursor.style.top = e.clientY + "px";
                    })
                    featuredBundlegallery.addEventListener('mouseleave', (e)=>{
                        if(customCursor.classList.contains('d-block')){
                            customCursor.classList.remove('d-block');
                        }
                    })
            })
        }
    }
    customCursor();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  const featuredSliders = document.querySelectorAll('.product_slider_js_featured');
  if(featuredSliders.length > 0) {

    let featuredSliderSettings = {
      loop: false,
      slidesPerView: 1.255,
      spaceBetween: 12,
      navigation: {
          nextEl: '.featured-swiper-button-next',
          prevEl: '.featured-swiper-button-prev',
      },
      breakpoints: {
          650: {
            slidesPerView: 2.15,
            spaceBetween: 24,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 24,
          },
          1024: {
              slidesPerView: 3,
              spaceBetween: 24,
          }
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        }
    };
    featuredSliders.forEach((section)=>{
      let parentEl = section.closest('.collection');
      let nextEl = parentEl.querySelector('.featured-swiper-button-next');
      let prevEl = parentEl.querySelector('.featured-swiper-button-prev');
      featuredSliderSettings['navigation']['nextEl'] = nextEl;
      featuredSliderSettings['navigation']['prevEl'] = prevEl;
      new Swiper(section,featuredSliderSettings );
    })

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footerold"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById("shopify-section-header");
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector("predictive-search");

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.addEventListener("scroll", this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.removeEventListener("scroll", this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add(
        "shopify-section-header-hidden",
        "shopify-section-header-sticky"
      );
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      this.header.classList.add("shopify-section-header-sticky", "animate");
      this.header.classList.remove("shopify-section-header-hidden");
    }
    reset() {
      this.header.classList.remove(
        "shopify-section-header-hidden",
        "shopify-section-header-sticky",
        "animate"
      );
    }
    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures || this.header.querySelectorAll("details-disclosure");
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal || this.header.querySelector("details-modal");

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define("sticky-header", StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"]) return;
  try {
    
  const imageSlider = new Swiper('.image-slider-js', {
    loop: false,
    slidesPerView: 3.052,
    navigation: {
      nextEl: '.swiper-button-next__image',
      prevEl: '.swiper-button-prev__image',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    breakpoints: {
      650: {
        slidesPerView: 4.6,
      },
      768: {
        slidesPerView: 5.6,
      },
      1024: {
        slidesPerView: 6,
      },
    },
  });

  imageSlider.slides.forEach((slide) => {
    const label = slide.dataset.swiperSlideLabel;
    if (label) {
      const existing = slide.getAttribute('aria-label');
      slide.setAttribute('aria-label', `${label}, ${existing}`);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["look-inside-box"] && !Shopify.designMode) return;
  try {
    
  const shopThePlayBoxes = document.querySelectorAll('.multiple-boxes');
  if (shopThePlayBoxes.length) {
    shopThePlayBoxes.forEach((room) => {
      room.parentNode.classList.add('main-multiple-playboxes');

      const roomDatasetPlayBox = room.dataset.room;
      if (roomDatasetPlayBox != null) {
        const playGroups = document.querySelectorAll(`[data-room="${roomDatasetPlayBox}"]`);

        if (playGroups.length > 1) {
          var list = '<ul>';
          var btnlist = '<ul class="btn-list list-unstyled">';
          Array.prototype.map.call(playGroups, function (data, index) {
            let listData = data.querySelector('button.dropdown-toggle').innerHTML;
            let bntListData = data.querySelector('.look-button-wrapper').innerHTML;
            data.querySelector('.look-button-wrapper').classList.add('d-none');

            let playGroupsPlay;
            let playGroupsPlayBtn;
            if (playGroups[index].classList.contains('multiple-boxes')) {
              playGroupsPlay = 'd-none';
              playGroupsPlayBtn = '';
            } else {
              playGroupsPlay = '';
              playGroupsPlayBtn = 'd-none';
            }

            list = `${list}<li class="${playGroupsPlay}">${listData}</li>`;
            if (bntListData.length > 0) {
              btnlist = `${btnlist}<li class="${playGroupsPlayBtn}">${bntListData}</li>`;
            }
          });
          list = `${list}</ul>`;
          btnlist = `${btnlist}</ul>`;

          var html = Array.prototype.reduce.call(
            playGroups,
            function (html, node) {
              if (node.classList.contains('multiple-boxes')) {
                node.querySelector('.liList').innerHTML = list;
                node.querySelector('.btnList').innerHTML = btnlist;
                node.querySelector('.dropDown__js');
              }
              return html + (node.outerHTML || node.nodeValue);
            },
            ''
          );

          room.parentNode.innerHTML = html;
        }
      }
    });

    const playTitles = document.querySelectorAll('.multiple-boxes .shop-the-room__title');
    playTitles.forEach((room) => {
      room.classList.add('dropDown__js');
      room.closest('.main-multiple-playboxes').prepend(room);
    });

    const playButtons = document.querySelectorAll('.main-multiple-playboxes .dropDown__js .btn-group button');
    playButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        btn.parentNode.querySelector('.liList').classList.toggle('open');
        btn.parentNode.classList.toggle('open');
      });
    });
  }

  const mainMultiplePlayBoxes = document.querySelectorAll('.main-multiple-playboxes');
  if (mainMultiplePlayBoxes) {
    mainMultiplePlayBoxes.forEach((singleRoom) => {
      const liListsPlay = singleRoom.querySelectorAll('.liList li');
      liListsPlay.forEach((list, index) => {
        list.addEventListener('click', (e) => {
          const sPlay = singleRoom.querySelectorAll('.shop-the-room');
          Array.prototype.map.call(sPlay, (rm, i) => {
            if (rm.classList.contains('multiple-boxes')) {
              rm.querySelector('.shop-the-room__wrap').classList.add('d-none');
            } else {
              rm.classList.add('d-none');
            }
          });
          const currentElPlay = singleRoom.querySelectorAll('.shop-the-room')[index];
          if (currentElPlay.classList.contains('multiple-boxes')) {
            currentElPlay.querySelector('.shop-the-room__wrap').classList.remove('d-none');
          } else {
            currentElPlay.classList.remove('d-none');
          }
          let listValue = list.innerHTML;
          //remove D-none from all li and add to the clicked one
          const ulElsPlay = list.closest('ul').querySelectorAll('li');
          const ulElsPlayBtn = list.closest('.shop-the-room__title').querySelectorAll('.btn-list li');

          if (ulElsPlayBtn.length > 0) {
            const ulElsPlayBtnIndex = ulElsPlayBtn[index];
            ulElsPlayBtn.forEach((btn) => {
              btn.classList.add('d-none');
            });

            ulElsPlayBtnIndex.classList.remove('d-none');
          }

          ulElsPlay.forEach((li) => {
            li.classList.remove('d-none');
          });
          list.classList.add('d-none');

          list.closest('.liList').classList.remove('open');
          list.closest('.btn-group').classList.remove('open');
          list.closest('.btn-group').querySelector('button').innerHTML = listValue;
        });
      });
    });
  }

  setTimeout(() => {
    let shopProductSlider = document.querySelectorAll('.look_inside_box_js');

    shopProductSlider.forEach((pSlider) => {
      const parentEl = pSlider.closest('.shop-the-room');
      const pagination = parentEl.querySelector('.swiper-pagination');
      const shopCountSlider = parentEl.querySelector('.shop-position-slider-js');

      var shopCount = new Swiper(shopCountSlider, {
        navigation: false,
        slidesPerView: 10,
      });

      var shopProduct = new Swiper(pSlider, {
        navigation: false,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: pagination,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        },
        thumbs: {
          swiper: shopCount,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        }
      });
    });
  }, 1000);

  let ps = document.querySelectorAll('.shop__content-support');
  let observer = new ResizeObserver((entries) => {
    for (let entry of entries) {
      entry.target.classList[entry.target.scrollHeight > entry.contentRect.height ? 'add' : 'remove']('truncated');
    }
  });

  if (ps) {
    ps.forEach((p) => {
      observer.observe(p);
    });
  }

  lookInsideBox = () => {
    var spots = document.querySelectorAll('.look-inside-box [data-spot="index-spot"]');

    spots.forEach((spot) => {
      spot.addEventListener('mouseover', function () {
        // Remove "preview" class from all spots
        spots.forEach((otherSpot) => {
          otherSpot.parentElement.classList.remove('active-spot', 'preview');
        });

        // Add "preview" class to the currently hovered spot
        spot.parentElement.classList.add('active-spot', 'preview');

        // Check if the mouse is not over the spot itself
        if (!spot.contains(event.target)) {
          spot.parentElement.classList.remove('active-spot', 'preview');
        } else {
          spot.parentElement.classList.add('active-spot', 'preview');
        }
      });

      document.addEventListener('click', function (event) {
        /**if clicked outside spot and its div content*/
        var container = spot.closest('.spots');
        var content = spot.parentElement.querySelector('.shop.look-inside-box');
        var cardVariant = spot.parentElement.querySelector('card-variant');

        if (!spot.contains(event.target) && !cardVariant.contains(event.target) && !content.contains(event.target)) {
          container.classList.remove('active-spot', 'preview');
        }
      });
    });

    /**if clicked outside dropdown*/
    document.addEventListener('click', function (event) {
      const dropDownJSAll = document.querySelectorAll('.section-shop-the-room .dropDown__js .btn-group');
      if (dropDownJSAll.length > 0) {
        dropDownJSAll.forEach((dropDownJS) => {
          if (!dropDownJS.contains(event.target)) {
            if (dropDownJS.classList.contains('open')) {
              dropDownJS.classList.remove('open');
              dropDownJS.querySelector('.liList').classList.remove('open');
            }
          }
        });
      }
    });
  };

  lookInsideBox();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    

if( document.querySelectorAll('.card--recommended ').length > 0){
  document.querySelector('main').classList.add('has-you-may-like');
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-old"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["play-box-look-into-the-box"] && !Shopify.designMode) return;
  try {
    
  setTimeout(() => {
    //const shopCountSlider = document.querySelectorAll('.shop-position-slider-js');
    const shopProductSlider = document.querySelectorAll('.look_inside_box_js');

    shopProductSlider.forEach((pSlider) => {
      const parentEl = pSlider.closest('.shop-the-room');
      const pagination = parentEl.querySelector('.swiper-pagination');
      const shopCountSlider = parentEl.querySelector('.shop-position-slider-js');

      var shopCount = new Swiper(shopCountSlider, {
        navigation: false,
        slidesPerView: 10,
      });

      var shopProduct = new Swiper(pSlider, {
        navigation: false,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: pagination,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        },
        thumbs: {
          swiper: shopCount,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        }
      });
    });
  }, 1000);

  const ps = document.querySelectorAll('.shop__content-support');
  const observer = new ResizeObserver((entries) => {
    for (let entry of entries) {
      entry.target.classList[entry.target.scrollHeight > entry.contentRect.height ? 'add' : 'remove']('truncated');
    }
  });

  if (ps) {
    ps.forEach((p) => {
      observer.observe(p);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-design-feature"] && !Shopify.designMode) return;
  try {
    
  const featureProductBtn = document.querySelectorAll('.product-design-feature .btn-addtocart');
  featureProductBtn.forEach((item) => {
      item.addEventListener('click', (e) => {
      let parentEl = e.target.closest('div[data-cart="shop_to_cart"]');
      parentEl.querySelector('[type="submit"]').click();
      })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        console.log('outside')
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (html.querySelector('.swiper-slide')) {
              this.classList.add('product-recommendations--loaded');

              const swiper = new Swiper('.related_product_slider_js', {
                loop: false,
                slidesPerView: 1.255,
                spaceBetween: 24,
                navigation: {
                    nextEl: '.recommended-swiper-button-next',
                    prevEl: '.recommended-swiper-button-prev',
                },
                mousewheel: {
                  enabled: true,
                  forceToAxis: true,
                },
                focusableElements: '.card__information',
                pagination: false,
                breakpoints: {
                    650: {
                      slidesPerView: 2.15
                    },
                    768: {
                      slidesPerView: 2.5
                    },
                    1024: {
                        slidesPerView: 3,
                    }
                  },

                });
            }

          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabbed-grid"] && !Shopify.designMode) return;
  try {
    
  const multipleTabbedCollection = document.querySelector('.dropDownTabbed__js');
  const collectionShape = document.querySelector('.collection-shape');
  const giftGuideAnchor = document.querySelector('.gift-guide-anchors-section');

  if (multipleTabbedCollection) {
    if( collectionShape ) {
      collectionShape.querySelectorAll('a[data-dropdown]').forEach(element => {
        element.addEventListener('click',debounce((e)=>{
          var gotoElm = element.getAttribute('data-dropdown');
          const listEl = document.querySelector('.dropDownTabbed__js .liList li[data-dropdownClicked="'+gotoElm+'"]');
          const btnListEl = document.querySelector('.dropDownTabbed__js .gift-btn-group .gift-btn[data-dropdownClicked="'+gotoElm+'"]');

          if (listEl) {
            listEl.dispatchEvent(new Event('click'));
          }

          if (btnListEl) {
            btnListEl.dispatchEvent(new Event('click'));
          }

          const scrollToViewDiv = document.getElementById("productGridTrigger");
          scrollToViewDiv.scrollIntoView();
        }),100)
      });
    }

    if(giftGuideAnchor) {
      giftGuideAnchor.querySelectorAll('a[data-dropdown]').forEach(element => {
        element.addEventListener('click',debounce((e)=>{
          var gotoElm = element.getAttribute('data-dropdown');
          const listElGift = document.querySelector('.dropDownTabbed__js .liList li[data-dropdownClicked="'+gotoElm+'"]');
          const btnListElGift = document.querySelector('.dropDownTabbed__js .gift-btn-group .gift-btn[data-dropdownClicked="'+gotoElm+'"]');

          if (listElGift) {
            listElGift.dispatchEvent(new Event('click'));
          }

          if (btnListElGift) {
            btnListElGift.dispatchEvent(new Event('click'));
          }

          const scrollToViewDiv = document.getElementById("productGridTrigger");
          scrollToViewDiv.scrollIntoView();
        }),100)
      });
    }
  } else {
    if( collectionShape ) {
      collectionShape.querySelectorAll('a[data-goto]').forEach(element => {
        element.addEventListener('click',debounce((e)=>{
          var gotoElm = element.getAttribute('data-goto');
          const tabEl = document.querySelector('.productGrid--title a[data-cliked="'+gotoElm+'"]');
          tabEl.dispatchEvent(new Event('click'));
        }),100)
      });
    }

    if( giftGuideAnchor ) {
      giftGuideAnchor.querySelectorAll('a[data-goto]').forEach(element => {
        element.addEventListener('click',debounce((e)=>{
          var gotoElm = element.getAttribute('data-goto');
          const tabElGift = document.querySelector('.productGrid--title a[data-cliked="'+gotoElm+'"]');
          tabElGift.dispatchEvent(new Event('click'));
        }),100)
      });
    }
  }

  function productGridSnap() {
    const el = document.getElementById("productGridTrigger");
    const elP = document.getElementById("titleWrapperTrigger");
    if (window.matchMedia("(max-width: 768px)").matches) {
      el.remove();
      elP.insertAdjacentHTML('beforebegin', '<span id="productGridTrigger" class="visibility-hidden"></span>')
    } else {
      el.remove()
      if (multipleTabbedCollection) {
        elP.querySelector('.h3-trigger').insertAdjacentHTML('beforebegin', '<span id="productGridTrigger" class="visibility-hidden"></span>')
      } else {
        elP.querySelector('.h3-trigger').insertAdjacentHTML('beforebegin', '<span id="productGridTrigger" class="visibility-hidden"></span>')
      }
    }
  }
  productGridSnap();
  window.addEventListener('resize', productGridSnap);

  const tabEl = document.querySelectorAll('.productGrid--title a[data-bs-toggle="tab"]')

  tabEl.forEach((i) => {
    i.addEventListener("click", debounce(function() {
      const el = document.getElementById("productGridTrigger");
        el.scrollIntoView();
    }),100);
  });

  const shopButton = document.querySelectorAll('.product-grid-wrapper.dropDownTabbed__js .btn-group button');
  if (shopButton) {
    shopButton.forEach((btn)=>{
      btn.addEventListener('click',(e)=>{
        btn.parentNode.querySelector('.liList').classList.toggle('open');
        btn.parentNode.classList.toggle('open');
      })
    })
  }


  if (multipleTabbedCollection) {
    const liLists = multipleTabbedCollection.querySelectorAll('.liList li');
    const btnListEl = multipleTabbedCollection.querySelectorAll('.dropDownTabbed__js .gift-btn-group .gift-btn');

    if (liLists) {
      liLists.forEach((list, index)=>{
        list.addEventListener('click',(e)=>{
          let listValue = list.innerHTML;
          const ulEls = list.closest('ul').querySelectorAll('li');
          const ulElsTabContent = multipleTabbedCollection.querySelectorAll('.collection-tabbed-container');

          if (ulElsTabContent.length > 0) {
            const ulElsTabContentIndex = ulElsTabContent[index];
            ulElsTabContent.forEach((tabContent) => {
              tabContent.classList.add('d-none');
            });

            ulElsTabContentIndex.classList.remove('d-none');
          }

          ulEls.forEach((li)=>{
            li.classList.remove('d-none');
          })
          list.classList.add('d-none');

          list.closest('.liList').classList.remove('open');
          list.closest('.btn-group').classList.remove('open');
          list.closest('.btn-group').querySelector('button').innerHTML = listValue;
        })
      })
    }

    if(btnListEl) {
      btnListEl.forEach((btn, index) => {
        btn.addEventListener('click',(e)=> {
          const ulElsGift = btn.closest('.gift-btn-group').querySelectorAll('.gift-btn');
          const ulElsTabContentGift = multipleTabbedCollection.querySelectorAll('.collection-tabbed-container');

          if (ulElsTabContentGift.length > 0) {
            const ulElsTabContentGiftIndex = ulElsTabContentGift[index];
            ulElsTabContentGift.forEach((tabContent) => {
              tabContent.classList.add('d-none');
            });

            ulElsTabContentGiftIndex.classList.remove('d-none');
          }

          ulElsGift.forEach((li)=>{
            li.classList.remove('active');
          })
          btn.classList.add('active');
        })
      })
    }
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-variant-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const productVariantCarousels = document.querySelectorAll('.product_variant_slider_js');

    if (productVariantCarousels.length > 0) {
      let productVariantCarouselSettings = {
        loop: false,
        slidesPerView: 1.255,
        spaceBetween: 24,
        dragSize: 50,
        longSwipesMs: 20,
        longSwipesRatio: 0.1,
        shortSwipes: false,
        navigation: {
          nextEl: '.collection-swiper-button-next',
          prevEl: '.collection-swiper-button-prev',
        },
        pagination: false,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          650: {
            slidesPerView: 2.15,
          },
          768: {
            slidesPerView: 2.5,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      };
      productVariantCarousels.forEach((item, index) => {
        new Swiper(item, productVariantCarouselSettings);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-shape-marquee"] && !Shopify.designMode) return;
  try {
    

  function cloneElement(el, n, deep) {
    for (var i = 0, clone; i < n - 1; i++) {
      clone = el.cloneNode(deep);
      clone.setAttribute('aria-hidden', 'true');
      el.parentNode.insertBefore(clone, el);
    }
  }

  let shapeMarquee = document.querySelectorAll('.scrollingShapeMarquee');
  shapeMarquee.forEach((shapeBlock) => {
    const eachBlock = shapeBlock.querySelector('.scrolling-shape-marquee__content');
    cloneElement(eachBlock, 5, true);
  });

  const wrappers = document.querySelectorAll('.scrolling-shape-marquee-wrapper');
  if (!wrappers.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  wrappers.forEach((wrapper) => {
    const toggleBtn = wrapper.querySelector('.scrolling-shape-marquee__toggle');
    const iconPlay = toggleBtn?.querySelector('.icon-play');
    const iconPause = toggleBtn?.querySelector('.icon-pause');

    if (!toggleBtn) return;

    let isRunning = !prefersReducedMotion;

    function updateAnimation() {
      wrapper.classList.toggle('is-playing', isRunning);

      if (iconPlay) iconPlay.style.display = isRunning ? 'none' : 'inline';
      if (iconPause) iconPause.style.display = isRunning ? 'inline' : 'none';

      toggleBtn.setAttribute(
        'aria-label',
        isRunning ? 'Pause marquee animation' : 'Play marquee animation'
      );

      toggleBtn.setAttribute('aria-pressed', isRunning ? 'false' : 'true');
    }

    toggleBtn.addEventListener('click', () => {
      isRunning = !isRunning;
      updateAnimation();
    });

    updateAnimation();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-room"] && !Shopify.designMode) return;
  try {
    
  const shopTheRooms = document.querySelectorAll('.multiple-rooms');
  if (shopTheRooms.length) {
    shopTheRooms.forEach((room) => {
      room.parentNode.classList.add('main-multiple-rooms');

      //const nextRoomClass = room.parentNode.next().classList.contains('.section-shop-the-room');
      const roomDataset = room.dataset.room;
      if (roomDataset != null) {
        const roomGroups = document.querySelectorAll(`[data-room="${roomDataset}"]`);

        if (roomGroups.length > 1) {
          var list = '<ul>';
          Array.prototype.map.call(roomGroups, function (data, index) {
            let listData = data.querySelector('button.dropdown-toggle').innerHTML;
            let liClass;
            if (roomGroups[index].classList.contains('multiple-rooms')) {
              liClass = 'd-none';
            } else {
              liClass = '';
            }
            list = `${list}<li class="${liClass}">${listData}</li>`;
          });
          list = `${list}</ul>`;

          var html = Array.prototype.reduce.call(
            roomGroups,
            function (html, node) {
              if (node.classList.contains('multiple-rooms')) {
                node.querySelector('.liList').innerHTML = list;
              }
              return html + (node.outerHTML || node.nodeValue);
            },
            ''
          );

          room.parentNode.innerHTML = html;
        }
      }
    });

    const roomTitles = document.querySelectorAll('.multiple-rooms .shop-the-room__title');
    roomTitles.forEach((room) => {
      //room.remove();
      room.classList.add('dropDown__js');
      room.closest('.main-multiple-rooms').prepend(room);
    });

    const buttons = document.querySelectorAll('.main-multiple-rooms .dropDown__js button');
    buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        btn.parentNode.querySelector('.liList').classList.toggle('open');
        btn.parentNode.classList.toggle('open');
      });
    });
    /*
    const liLists = document.querySelectorAll('.liList li');
    liLists.forEach((list)=>{
        list.addEventListener('click',(e)=>{
            let listValue = list.innerHTML;
            list.closest('.liList').classList.remove('open');
            list.closest('.btn-group').querySelector('button').innerHTML = listValue;
        })
    })
    */

    //const shopTheRooms = document.querySelectorAll('.multiple-rooms');
  }

  const mainMultipleRooms = document.querySelectorAll('.main-multiple-rooms');
  if (mainMultipleRooms) {
    mainMultipleRooms.forEach((singleRoom) => {
      const liLists = singleRoom.querySelectorAll('.liList li');
      liLists.forEach((list, index) => {
        list.addEventListener('click', (e) => {
          //const index2 = [...list.parentElement.children].indexOf(list)
          const sRoom = singleRoom.querySelectorAll('.shop-the-room');
          Array.prototype.map.call(sRoom, (rm, i) => {
            if (rm.classList.contains('multiple-rooms')) {
              rm.querySelector('.shop-the-room__content').classList.add('d-none');
            } else {
              rm.classList.add('d-none');
            }
          });
          const currentEl = singleRoom.querySelectorAll('.shop-the-room')[index];
          if (currentEl.classList.contains('multiple-rooms')) {
            currentEl.querySelector('.shop-the-room__content').classList.remove('d-none');
          } else {
            currentEl.classList.remove('d-none');
          }
          let listValue = list.innerHTML;
          //remove D-none from all li and add to the clicked one
          const ulEls = list.closest('ul').querySelectorAll('li');
          ulEls.forEach((li) => {
            li.classList.remove('d-none');
          });
          list.classList.add('d-none');

          list.closest('.liList').classList.remove('open');
          list.closest('.btn-group').classList.remove('open');
          list.closest('.btn-group').querySelector('button').innerHTML = listValue;
        });
      });
    });
  }

  setTimeout(() => {
    //const shopCountSlider = document.querySelectorAll('.shop-position-slider-js');
    const shopProductSlider = document.querySelectorAll('.shop_slider_js');

    shopProductSlider.forEach((pSlider) => {
      const parentEl = pSlider.closest('.shop-the-room');
      const pagination = parentEl.querySelector('.swiper-pagination');
      const shopCountSlider = parentEl.querySelector('.shop-position-slider-js');

      var shopCount = new Swiper(shopCountSlider, {
        navigation: false,
        slidesPerView: 5,
      });

      var shopProduct = new Swiper(pSlider, {
        navigation: false,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: pagination,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        thumbs: {
          swiper: shopCount,
        },
      });
    });
  }, 1000);

  const shopTheRoomIcons = document.querySelectorAll('.shop-the-room__content .shop__checker_icon');
  if (shopTheRoomIcons) {
    const variantEls = document.querySelectorAll('.shop-the-room__content .color-variation a');
    variantEls.forEach((variant) => {
      variant.addEventListener('click', (e) => {
        e.preventDefault();
        let parentElm = e.target.closest('div[data-cart="shop_to_cart"]');
        let productForm = parentElm.querySelector('product-form');
        productForm.querySelector('input[name="id"]').value = e.target.dataset.variantId;
        if (e.target.closest('.thumb-product-card')) {
          e.target.closest('.thumb-product-card').querySelector('.shop__checker').classList.remove('checked');
          if (document.querySelector('.add-to-cart-text')) {
            document.querySelector('.add-to-cart-text').remove();
          }
        }
      });
    });

    shopTheRoomIcons.forEach((icon) => {
      icon.addEventListener('click', (e) => {
        let parentEl = e.target.closest('div[data-cart="shop_to_cart"]');
        var checkedValue = e.target.parentNode.classList.toggle('checked');
        if (e.target.parentNode.classList.contains('checked')) {
          icon
            .closest('.thumb-product-card')
            .querySelector('card-variant')
            .insertAdjacentHTML(
              'beforeend',
              '<div class="add-to-cart-text add-to-cart-text--shop icon-tick text-basil body-sm position-absolute bottom-0 end-0 mb-1"><span class="ms-1">Added to cart</span></div>'
            );
          icon.closest('.thumb-product-card').classList.add('checked');
          parentEl.querySelector('.product-form').querySelector('form').querySelector('[type="submit"]').click();
          setTimeout(() => {
            e.target.parentNode.classList.remove('checked');

            document.querySelector('.add-to-cart-text').remove();
            icon.closest('.thumb-product-card').classList.remove('checked');
          }, 10000);
        } else {
          parentEl.querySelector('.card-variants').classList.remove('pe-none');
          icon.closest('.thumb-product-card').querySelector('.add-to-cart-text').remove();
          icon.closest('.thumb-product-card').classList.remove('checked');
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  let tabbedTestimonialWrapper = document.querySelectorAll('.tabbed-testimonial-slider');

  tabbedTestimonialWrapper.forEach(element => {
    let tabbedSliderLogoJs = element.querySelector('.press-testimonial-logo-slider-js');

        let quoteLogoSlide = new Swiper(tabbedSliderLogoJs, {
          navigation: false,
          observer: true,
          observeParents: true,
          slidesPerView: 10,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          }
        });

        let slides = element.querySelectorAll('.hover-slide .swiper-slide');
        function tabbedQuoteSlideChange(slideCard) {
          slides.forEach((slide , index) => {
            slide.addEventListener("mouseenter", ()=>{
              slideCard.slideTo(index)
            });
          });
        }

        let sliderTabbedQuoteJs = element.querySelector('.press-testimonial-slider-js');

        if (sliderTabbedQuoteJs) {
          if (sliderTabbedQuoteJs.classList.contains('autoplay-slide')) {
            let tabbedQuoteSlide = new Swiper(sliderTabbedQuoteJs, {
              navigation: false,
              effect: "fade",
              observer: true,
              observeParents: true,
              autoplay: {
                disableOnInteraction: false,
              },
              thumbs: {
                swiper: quoteLogoSlide,
              },
              mousewheel: {
                enabled: true,
                forceToAxis: true,
              }
            });
            tabbedQuoteSlideChange(tabbedQuoteSlide)
          }
          else {
            let tabbedQuoteSlide = new Swiper(sliderTabbedQuoteJs, {
              navigation: false,
              effect: "fade",
              observer: true,
              observeParents: true,
              thumbs: {
                swiper: quoteLogoSlide,
              },
              mousewheel: {
                enabled: true,
                forceToAxis: true,
              }
            });
            tabbedQuoteSlideChange(tabbedQuoteSlide)
          }
        }


        let realpplQuoteJs = element.querySelector('.realppl-testimonial-slider-js');
        if (realpplQuoteJs) {
          let realpplQuoteSlide = new Swiper(realpplQuoteJs, {
            navigation: false,
            effect: "fade",
            observer: true,
            observeParents: true,
            autoplay: {
              disableOnInteraction: false,
            },
            mousewheel: {
              enabled: true,
              forceToAxis: true,
            }
          });
        }
  });

  const tabs = document.querySelectorAll('.testimonial-tab__link');

  if (tabs.length) {
    const setActiveTab = (activeTab) => {
      tabs.forEach((tab) => {
        const isActive = tab === activeTab;

        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => setActiveTab(tab));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    

    let testimonialWrapper = document.querySelectorAll('.testimonial-slider');

    testimonialWrapper.forEach((e) => {
        let sliderLogoJs = e.querySelector('.testimonial-logo-slider-js');

        let logoSlide = new Swiper(sliderLogoJs, {
            navigation: false,
            slidesPerView: 10,
            mousewheel: {
                enabled: true,
                forceToAxis: true,
            }
        });

        let slides = e.querySelectorAll('.hover-slider .swiper-slide');

        function quoteSlideChange(slideCard) {
            slides.forEach((slide , index) => {
                slide.addEventListener("mouseenter", ()=>{
                    slideCard.slideTo(index)
                });
            });
        }


        let sliderQuoteJs = e.querySelector('.testimonial-slider-js');

        if (sliderQuoteJs.classList.contains('autoplay-slide')) {
            let quoteSlide = new Swiper(sliderQuoteJs, {
                navigation: false,
                effect: "fade",
                autoplay: {
                    disableOnInteraction: false,
                },
                thumbs: {
                    swiper: logoSlide,
                },
                mousewheel: {
                    enabled: true,
                    forceToAxis: true,
                }
            });
            quoteSlideChange(quoteSlide)
        }
        else {
            let quoteSlide = new Swiper(sliderQuoteJs, {
                navigation: false,
                effect: "fade",
                thumbs: {
                    swiper: logoSlide,
                },
                mousewheel: {
                    enabled: true,
                    forceToAxis: true,
                }
            });
            quoteSlideChange(quoteSlide)
        }
    })


  } catch(e) { console.error(e); }
})();
})();
